var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 20.5H6C4.93913 20.5 3.92172 20.0786 3.17157 19.3284C2.42143 18.5783 2 17.5609 2 16.5V7.5C2 6.43913 2.42143 5.42172 3.17157 4.67157C3.92172 3.92143 4.93913 3.5 6 3.5H17C18.0609 3.5 19.0783 3.92143 19.8284 4.67157C20.5786 5.42172 21 6.43913 21 7.5V10.5M8 2.5V4.5M15 2.5V4.5M2 8.5H21M18.5 16.143L17 17.643",
    stroke: "#04245C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22.5C19.7614 22.5 22 20.2614 22 17.5C22 14.7386 19.7614 12.5 17 12.5C14.2386 12.5 12 14.7386 12 17.5C12 20.2614 14.2386 22.5 17 22.5Z",
    stroke: "#2173FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleIcon);
export default __webpack_public_path__ + "static/media/schedule_icon.8bce16e1281c2b31791692fe11087b7f.svg";
export { ForwardRef as ReactComponent };